// code commented for phase 1

import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import LinearProgressBar from "../../../../Components/LinearProgressBar";
import { useTranslation } from "react-i18next";

export default function GetStartedContent({
  isCommunityManagementRole,
  modalPosition,
  isBelowMd,
  getStartedContent,
  closeDrawer,
  handleCloseGenericModal,
}) {
  const { t } = useTranslation("bottom-menu-and-settings");
  const { supplierTasks, getStartedTasks } = getStartedContent;

  const {
    bookedJob,
    businessStandoutCompleted,
    joinedCommunity,
    paymentMethodsSetup,
    pricedService,
    percentageComplete: supplierPercentageComplete,
  } = supplierTasks || {};

  const {
    communityShineCompleted: communityShine,
    supplierCount,
    // membersAdded,
    percentageComplete: adminPercentageComplete,
  } = getStartedTasks || {};

  const taskRoutes = useMemo(
    () => ({
      admin: [
        {
          key: "communityShine",
          status: communityShine,
          statement: t("communityTasks.communityShine"),
          route: "/community-settings",
          available: true,
        },
        {
          key: "supplierCount",
          status: supplierCount?.completed,
          statement: t("communityTasks.supplierCount"),
          // route: "/find-suppliers",
          // change the route for phase1 as "/find-suppliers" is disabled in phase1
          route: "/my-suppliers",
          available: true,
        },
        // {
        //   key: "membersAdded",
        //   status: membersAdded?.completed,
        //   statement: t("communityTasks.membersAdded"),
        //   route: "/my-members",
        //   available: true,
        // },
      ],
      supplier: [
        {
          key: "businessStandout",
          status: businessStandoutCompleted,
          statement: t("supplierTasks.businessStandout"),
          route: "/business-settings",
          available: true,
        },
        {
          key: "paymentMethodsSetup",
          status: paymentMethodsSetup,
          statement: t("supplierTasks.paymentMethodsSetup"),
          route: "/business-settings",
          available: true,
        },
        {
          key: "pricedService",
          status: pricedService,
          statement: t("supplierTasks.pricedService"),
          route: "/manage-pricelists",
          available: true,
        },
        {
          key: "joinedCommunity",
          status: joinedCommunity,
          statement: t("supplierTasks.joinedCommunity"),
          route: "/my-communities",
          state: { activeTab: 2 },
          available: true,
        },
        {
          key: "bookedJob",
          status: bookedJob,
          statement: t("supplierTasks.bookedJob"),
          route: null,
          available: false,
        },
      ],
    }),
    [
      bookedJob,
      businessStandoutCompleted,
      joinedCommunity,
      paymentMethodsSetup,
      pricedService,
      communityShine,
      supplierCount,
      // membersAdded,
      t,
    ]
  );

  const tasks = useMemo(() => {
    const selectedTasks = isCommunityManagementRole ? taskRoutes.admin : taskRoutes.supplier;

    // Filter out unavailable tasks and sort done tasks first
    return selectedTasks
      .filter((task) => task.available)
      .sort((a, b) => (b.status ? 1 : 0) - (a.status ? 1 : 0));
  }, [isCommunityManagementRole, taskRoutes]);

  const anyItemDone = tasks.some((item) => item.status);

  const webStyling = {
    position: "absolute",
    top: `${modalPosition.top - 175}px`,
    left: `280px`,
    bgcolor: "background.paper",
    p: "24px",
    height: "auto",
    borderRadius: "12px",
    minWidth: "300px",
    maxWidth: "320px",
    boxShadow: 3,
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "50%",
      left: "-12px",
      transform: "translateY(50%)",
      width: 0,
      height: 0,
      borderTop: "16px solid transparent",
      borderBottom: "16px solid transparent",
      borderRight: "16px solid white",
    },
  };

  const mobileStyling = {
    display: "flex",
    flexDirection: "column",
    ml: "14px",
  };

  return (
    <Box sx={isBelowMd ? mobileStyling : webStyling}>
      {!isBelowMd && (
        <Box sx={{ mb: "16px" }}>
          <LinearProgressBar
            percentage={
              isCommunityManagementRole ? adminPercentageComplete : supplierPercentageComplete
            }
            showPercentageText={true}
          />
        </Box>
      )}

      {tasks.map((item, index) => (
        <Box
          key={item.key}
          sx={{
            mb: index === tasks.length - 1 ? "0px" : "24px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {item.status ? (
            <img src="/icons/check-icon.svg" alt="check" width={10} />
          ) : anyItemDone ? (
            <Box sx={{ width: "10px", height: "7px" }} />
          ) : (
            <></>
          )}
          <Typography
            component={item.route && !item.status ? NavLink : "span"}
            to={item.route && !item.status ? item.route : undefined}
            state={
              item.route && !item.status && item.state ? item.state : undefined
            }
            onClick={() => {
              if (item.route && !item.status) {
                closeDrawer && closeDrawer();
                handleCloseGenericModal && handleCloseGenericModal();
              }
            }}
            sx={{
              ml: item.status || anyItemDone ? "14px" : "0px",
              fontSize: "13px",
              fontWeight: "400",
              color: item.status
                ? "rgba(47, 43, 61, 0.4)"
                : "rgba(47, 43, 61, 0.9)",
              textDecoration: item.status
                ? "line-through"
                : item.route
                  ? "underline"
                  : "none",
              cursor: item.route && !item.status ? "pointer" : "default",
              transition: "color 0.2s ease-in-out",
              "&:hover": {
                color:
                  item.route && !item.status
                    ? "rgba(70, 160, 145, 1)"
                    : undefined,
              },
            }}
          >
            {item.statement}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
